import React, { useMemo } from "react";
import { Breadcrumb, Typography } from "antd";

import type { State } from "router5";

import type { Dispatch } from "@reduxjs/toolkit";

import type { IntlShape } from "@formatjs/intl";

const dzProjects = <Typography.Text>DZ Projects</Typography.Text>;

type AppBreadCrumbsProps = {
  dispatch: Dispatch;
  intl: IntlShape;
  route: State;
};

const separator = <Typography.Text>›</Typography.Text>;

export const AppBreadCrumbs: React.FC<AppBreadCrumbsProps> = (props) => {
  const { dispatch, route, intl } = props;

  if (!route) {
    return null;
  }

  const subheader = {
    title: intl.formatMessage({ id: "breadcrumb_" + route?.name.replace(/\./g, "_") }),
    breadCrumbItems: route?.name.split(".").map((segment, index, parts) => {
      const subRouteParts = parts.slice(0, index + 1);
      return {
        title: (
          <Typography.Text>
            {intl.formatMessage({ id: "breadcrumb_" + subRouteParts.join("_") })}
          </Typography.Text>
        ),
        pathname: subRouteParts.join("."),
        routeParameters: route.params,
      };
    }),
  };

  return (
    <Breadcrumb
      items={[
        { title: dzProjects },
        subheader.breadCrumbItems[subheader.breadCrumbItems?.length - 1],
      ]}
      separator={separator}
    />
  );
};
